import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Loads data, keeping the current filter, page and selected item
 */
export class LoadDataKeepFilterKeepSelectionGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const workspace = this.workspace;
    const grid = workspace.grid;

    const selectedOid = grid.selectedItem?.[workspace.oidPropertyName] || null;

    grid.applyFilter(grid.state.filter, selectedOid);
  }
}
